module.exports = __webpack_public_path__ + "img/sales.0398ae14.svg";